import React, { ChangeEvent } from "react";
import styled from "styled-components";

const FileUplodaWrapper = styled.div`
  margin-top: 12px;
  display: flex;
  align-items: center;
  width: 60%;
  justify-content: space-between;
  @media ${(props) => props.theme.device.laptop} {
    width: 100%;
  }
`;
const FileLabel = styled.label<{ labelWidth?: number }>`
  font-size: 20px;
  min-width: 100px;
  width: ${(props) => `${props.labelWidth}%`};
  color: #666;
  @media ${(props) => props.theme.device.laptop} {
    font-size: 16px;
  }
  @media ${(props) => props.theme.device.mobile} {
    font-size: 12px;
  }
`;
const Box = styled.div<{ inputWidth: number }>`
  display: flex;
  width: ${(props) => `${props.inputWidth}%`};
  align-items: center;
`;
const InputButtonWrapper = styled.div<{ inputWidth?: number }>`
  display: flex;
  border: solid 1px #666;
  border-radius: 4px;
  /* padding: 4px; */
  height: 25px;
  width: ${(props) => `${props.inputWidth}%`};

  /* justify-content: space-between; */
`;

const InputLabel = styled.label`
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 60px;

  &:hover {
    cursor: pointer;
  }
  > p {
    font-size: 12px;
    @media ${(props) => props.theme.device.laptop} {
      font-size: 10px;
    }
  }
`;

const FileName = styled.div`
  margin-left: 12px;
  display: flex;
  align-items: center;
  font-size: 12px;
  color: red;
  @media ${(props) => props.theme.device.laptop} {
    font-size: 8px;
  }
`;

interface FileProps {
  //파일 업로드 타입 x
  // handleChangeFile: (event: React.ChangeEvent<HTMLInputElement>) => void;
  inputWidth: number;
  labelWidth: number;
  setUploadFile: (file: File | null) => void;
  uploadFile: File | null;
}

function FielUpload(props: FileProps) {
  const { inputWidth, labelWidth, setUploadFile, uploadFile } = props;

  const handleChangeFile = (event: ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    // console.log(file);
    if (!file) return;

    const fileExtension = file.name.split(".").pop();
    if (fileExtension !== "zip") {
      alert("zip파일 형식만 가능합니다");
      return;
    }

    //파일사이즈
    const fileSize = file.size;
    //최대 파일사이즈
    const maxSize = 20000000;
    if (fileSize > maxSize) {
      alert(`20MB 이내의 파일만 첨부 가능합니다.\n현재 파일크기_${(file.size / (1000 * 1000)).toFixed(1)}MB`);
      setUploadFile(null);
    } else if (fileSize < maxSize) {
      setUploadFile(file);
    }
  };

  return (
    <FileUplodaWrapper>
      <FileLabel labelWidth={labelWidth}>첨부파일</FileLabel>
      <Box inputWidth={inputWidth}>
        <InputButtonWrapper>
          <InputLabel htmlFor="input-file">
            <p>첨부하기</p>
          </InputLabel>
        </InputButtonWrapper>
        <FileName>
          {!!uploadFile && uploadFile !== null ? (
            <p>{uploadFile.name}</p>
          ) : (
            <p>.zip파일 형식만 가능합니다. 첨부파일의 크기를 20MB 이내로 첨부해주세요</p>
          )}
        </FileName>
      </Box>
      <input hidden id="input-file" name="file" type="file" accept=".zip, .rar, .7zip" onChange={handleChangeFile} />
    </FileUplodaWrapper>
  );
}

export default FielUpload;
